import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import logo from "../../assets/logo.png";

import {
  Anchor,
  Burger,
  Drawer,
  Flex,
  Group,
  MediaQuery,
  Paper,
  Text,
} from "@mantine/core";
import { Link, Navigate, useNavigate } from "react-router-dom";
import routeNames from "../../routes/routeNames";
import LoggedInUserProfile from "../loggedInUserProfile";
import SideBar from "./Sidebar";
import Button from "../Button";
import { useMediaQuery } from "@mantine/hooks";
import NotificationsTab from "../NotificationTabs";

const NavBarComponent = ({ links, internalLinks, extaLinks }) => {
  console.log("hello links", extaLinks);
  const matches1200 = useMediaQuery("(min-width: 1200px)");
  const matches800 = useMediaQuery("(min-width: 1000px)");
  const navigate = useNavigate();
  const [opened, setOpened] = useState(false);

  return (
    <>
      <MediaQuery largerThan="md" styles={{ display: "none" }}>
        <Paper
          radius={0}
          style={{
            position: "fixed",
            width: "100%",
            zIndex: 1000,
            height: "70px",
            padding: "0 20px",
            backgroundColor: "black",
          }}
        >
          <Group
            position="apart"
            noWrap
            style={{
              height: "100%",
              width: "100%",
            }}
          >
            <Burger
              opened={opened}
              onClick={() => setOpened((o) => !o)}
              size="sm"
              mr="xl"
              color="white"
            />
            <Drawer
              styles={{
                drawer: {
                  backgroundColor: "black",
                },
              }}
              opened={opened}
              onClose={() => setOpened(false)}
              title="Dashboard Options"
              padding="md"
              size="md"
              position="left"
            >
              <SideBar
                setOpened={setOpened}
                links={extaLinks ? extaLinks.concat(links) : links}
              />
            </Drawer>
            <Anchor component={Link} to={routeNames.general.landing}>
              <img src={logo} width="100%" height="100%" alt="logo" />
            </Anchor>
            {internalLinks ? (
              <Flex gap={"sm"}>
                <NotificationsTab />
                <LoggedInUserProfile internalLinks={internalLinks} />
              </Flex>
            ) : (
              <Group position="right">
                <Button
                  title={"Login"}
                  fontWeight="700"
                  primary={true}
                  onClick={() => {
                    navigate(routeNames.general.login);
                  }}
                />
              </Group>
            )}
          </Group>
        </Paper>
      </MediaQuery>
      <MediaQuery smallerThan="md" styles={{ display: "none" }}>
        <Paper
          radius={0}
          style={{
            position: "fixed",
            width: "100%",
            zIndex: 1000,
            height: "70px",
            padding: "0 20px",
            backgroundColor: "black",
          }}
        >
          <Group
            position="apart"
            align="center"
            style={{
              height: "100%",
              width: "100%",
            }}
          >
            <Anchor component={Link} to={routeNames.general.landing}>
              <img src={logo} width="100%" height="100%" alt="logo" />
            </Anchor>

            <Group spacing={matches1200 ? 45 : matches800 ? "lg" : 10}>
              {links.map((link, index) => {
                return (
                  <Anchor
                    variant="text"
                    key={index}
                    component={Link}
                    to={link.link}
                    sx={{
                      ":hover": {
                        color: "white",
                        borderBottom:
                          link.link !== window.location.pathname &&
                          "2px solid white",
                      },
                    }}
                  >
                    <Text
                      size="lg"
                      color={
                        link.link === window.location.pathname ? "red" : "white"
                      }
                      style={{
                        borderBottom:
                          link.link === window.location.pathname &&
                          "3px solid red",
                      }}
                    >
                      {link.label}
                    </Text>
                  </Anchor>
                );
              })}
            </Group>
            {/* {internalLinks && } */}
            {internalLinks ? (
              <Group>
                <NotificationsTab />
                <LoggedInUserProfile internalLinks={internalLinks} />
              </Group>
            ) : (
              <Group position="right">
                <Button
                  title={"Login"}
                  fontWeight="700"
                  onClick={() => {
                    navigate(routeNames.general.login);
                  }}
                  primary={true}
                />
              </Group>
            )}
          </Group>
        </Paper>
      </MediaQuery>
    </>
  );
};

export default withTranslation()(NavBarComponent);
